module.exports = __webpack_public_path__ + "static/media/noseSneerLeft.76d917d8.obj";